import Router from 'next/router';
import { parseCookies } from 'nookies';
import type { RedirectToOtherDomain } from '@/types';
import { PAGES } from '@/constants/pages';

export const redirectToCheckout = (url: string, ctx: any) => {
  redirect(`checkout/${url}`, ctx);
};

export const redirectToPrivateWebsite = (ctx: any) => {
  redirect(PAGES.PRIVATE_WEBSITE.replace('/', ''), ctx);
};

export const redirectToHome = (ctx, any) => {
  redirect('', ctx);
};

export const redirect = (url: string, ctx: any, status = 302) => {
  if (ctx?.res) {
    const location = url.startsWith(ctx.locale) ? `/${url}` : `/${ctx.locale}/${url}`;
    ctx.res.writeHead(status, {
      Location: location
    });
    ctx.res.end();
  } else {
    Router.push(`/${url}`);
  }
};

export const redirectToOtherDomain = ({ redirectUrl } : RedirectToOtherDomain) => {
  const token = parseCookies().token;
  const url = new URL(redirectUrl);
  url.searchParams.set('token', token);
  url.searchParams.set('redirect', 'true');

  window.location.href = url.toString();
};
